import React, { PureComponent } from 'react';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import cn from 'classnames';
import {
  Popover,
  PopoverHeader,
  PopoverBody,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
} from 'reactstrap';
import { func, bool } from 'prop-types';
import { FMessage } from '../../hoc/IntlComponents';

class PresetForm extends PureComponent {
  static propTypes = {
    onSave: func.isRequired,
    onCancel: func.isRequired,
    open: bool.isRequired,
    intl: intlShape.isRequired,
  };

  state = {
    errors: {},
    name: '',
  };

  togglePopover = () => {
    this.setState(() => ({ name: '', errors: {} }));
    this.props.onCancel();
  };

  handleChange = ({ target }) => {
    this.setState(() => ({
      [target.name]: target.value,
    }));
  };

  handleSubmit = (e) => {
    e.preventDefault();

    const { name } = this.state;
    const errors = {};

    if (!name) {
      errors.name = 'statistics.preset.modal.empty';
      this.setState(() => ({ errors }));
    } else {
      this.props.onSave(name);
    }
  };

  render() {
    const { name, errors } = this.state;
    const { open, intl, target } = this.props;

    return (
      <Popover
        backdrop="static"
        toggle={this.togglePopover}
        isOpen={open}
        target={target}
        placement="bottom"
        trigger="legacy"
      >
        <Form
          onSubmit={this.handleSubmit}
          autoComplete="off"
          className="statistics-presets-popover-form"
        >
          <PopoverHeader className="statistics-presets-popover-header">
            <FormattedMessage
              id="statistics.preset.modal.title"
              defaultMessage="Create new preset"
            />
          </PopoverHeader>

          <PopoverBody className="no-padding statistics-presets-popover">
            <FormGroup className={cn('form-group-upper-label', { 'has-error': errors.name })}>
              <Label>
                <FormattedMessage
                  id="statistics.preset.modal.placeholder"
                  defaultMessage="Preset name"
                />
              </Label>

              <Input name="name" onChange={this.handleChange} value={name} autoFocus bsSize="sm" />
              {errors.name && (
                <small className="form-text">
                  <FMessage id={errors.name} />
                </small>
              )}
            </FormGroup>
            <div className="statistics-presets-popover-buttons">
              <Button type="submit" size="sm" color="primary">
                <FormattedMessage id="main.save" defaultMessage="Save" />
              </Button>
            </div>
          </PopoverBody>
        </Form>
      </Popover>
    );
  }
}

export default injectIntl(PresetForm);
